export const projects = [
	{
		img: 'https://user-images.githubusercontent.com/53153822/143931821-e4a554d2-891b-4a92-a962-678d12a762d7.png',
		title: 'Lynda clone',
		des: 'Lynda is an E-learning Platform by LinkedIn. Built with HTML,CSS, and Js.Have features that allow users to buy subscriptions after creating an account on it. Also have features that users sort courses according to views count.',
		demo: '',
		live: 'https://linkedin-learning-clone.herokuapp.com/index', // deployed link
		gitHub: 'https://github.com/RanuRanjan/LyndaClone.github.io',
		technologies: [ 'HTML', 'CSS', 'JavaScript'],
	},
	{
		img: 'https://user-images.githubusercontent.com/53153822/143927187-b3139b2d-6f8c-4f5e-8a6e-e88566577a51.png',
		title: 'Tomtop Clone',
		des: 'An E-commerce website where users can buy any electronics and home accessories products from all over the world.Have features that allow users to add products to the cart, buy them and also sort the products on the basis of price.',
		demo: '',
		live: 'https://ranuranjan.github.io/TomtopClone/',
		gitHub: 'https://github.com/RanuRanjan/TomtopClone',
		technologies: [ 'HTML', 'CSS', 'JavaScript']
	},
	{
		img: 'https://user-images.githubusercontent.com/53153822/141642626-09016284-eeb1-4eec-82b9-92fc31ce5ba8.png',
		title: 'RedBus Clone',
		des: 'RedBus is India’s largest online bus ticketing platform that has transformed bus travel in the country by bringing ease and convenience to millions of Indians who travel using buses.It has features for login/logout . Users can search vehicles according to their needs.Users also book Outstation Vehicle . Users get ticket after successful booking.',
		demo: '',
		live: 'https://front-end-mansur3.vercel.app/',
		gitHub: 'https://github.com/RaniKamna/Redbus_clone',
		technologies: ['React', 'Redux', 'HTML', 'CSS', 'JavaScript','MongoDB'],
	},
	{
		img: 'https://user-images.githubusercontent.com/53153822/150516434-844b901d-7175-4f51-bd24-359ca1ccf3c8.jpg',
		title: 'Weather App',
		des: 'Weather App Using React. Users can search their city temp,wind,humidity ',
		demo: '',
		live: 'weather-app-zeta-fawn.vercel.app',
		gitHub: 'https://github.com/RanuRanjan/WeatherApp',
		technologies: ['React', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://user-images.githubusercontent.com/53153822/153553863-0c7453fe-9bb5-4720-b6d7-5591511f7bfe.jpg',
		title: 'Calculator',
		des: 'This calculator app where users can perform basic arithmetic operations',
		demo: '',
		live: 'https://ranuranjan.github.io/Calculator/',
		gitHub: 'https://github.com/RanuRanjan/Calculator',
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://user-images.githubusercontent.com/53153822/153556628-08dd58da-3360-4c81-a7bf-96877e860856.jpg',
		title: 'Todo',
		des: 'Simple Todo App. Users can add What they want do ,Users can mark task if done and also users can delete task',
		demo: '',
		live: 'https://ranuranjan.github.io/Todo/',
		gitHub: 'https://github.com/RanuRanjan/Todo',
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
];
